var b=Object.defineProperty,h=Object.defineProperties;var S=Object.getOwnPropertyDescriptors;var u=Object.getOwnPropertySymbols;var x=Object.prototype.hasOwnProperty,z=Object.prototype.propertyIsEnumerable;var a=(t,e,i)=>e in t?b(t,e,{enumerable:!0,configurable:!0,writable:!0,value:i}):t[e]=i,l=(t,e)=>{for(var i in e||(e={}))x.call(e,i)&&a(t,i,e[i]);if(u)for(var i of u(e))z.call(e,i)&&a(t,i,e[i]);return t},f=(t,e)=>h(t,S(e));(function(t,e){typeof exports=="object"&&typeof module!="undefined"?e(exports,require("@bedrock-layout/spacing-constants"),require("styled-components")):typeof define=="function"&&define.amd?define(["exports","@bedrock-layout/spacing-constants","styled-components"],e):(t=typeof globalThis!="undefined"?globalThis:t||self,e(t.grid={},t.spacingConstants,t.styled))})(this,function(t,e,i){"use strict";function p(r){return r&&typeof r=="object"&&"default"in r?r:{default:r}}var c=p(i);const d=c.default.div.attrs(({style:r,theme:n,minItemWidth:o,gutter:g})=>{var s;const m=(s=e.getSizeValue(n,o))!=null?s:o,v=e.getSafeGutter(n,g);return{"data-bedrock-grid":"",style:f(l({},r),{"--gutter":v,"--minItemWidth":m})}})`
  @property --gutter {
    syntax: "<length-percentage>";
    inherits: false;
    initial-value: 0;
  }

  @property --minItemWidth {
    syntax: "<length-percentage>";
    inherits: false;
    initial-value: ${e.sizes.small};
  }

  box-sizing: border-box;
  > * {
    margin: 0;
  }

  display: grid;
  gap: var(--gutter, 0px);

  grid-template-columns: repeat(
    auto-fit,
    minmax(min(var(--minItemWidth, ${e.sizes.small}), 100%), 1fr)
  );
`;d.displayName="Grid";function y({minItemWidth:r},n){if(r===void 0)return;typeof r=="number"||e.checkIsCSSLength(r)||Object.keys(e.sizes).includes(r)||console.error(`${n} needs to be an number, CSSLength or SizesOptions`)}d.propTypes={gutter:e.validateGutter,minItemWidth:y},t.Grid=d,Object.defineProperties(t,{__esModule:{value:!0},[Symbol.toStringTag]:{value:"Module"}})});
